//env=live
/* eslint-disable */

const env = {
    'feedBaseUrl': '//notifications.files.bbci.co.uk/',
    'feedAggregatedInitialFeed': 'latest.json',
    'feedTopicInitialFeed': 'latest.json',
    'feedTopicMaxSubscriptions': -1,
    'preferencesUrls': {
        'get': 'https://preferences.notifications.api.bbc.co.uk/subscriptions',
        'postPreference': 'https://preferences.notifications.api.bbc.co.uk/preference',
        'postPreferenceRelay': 'https://preferences.notifications.api.bbc.co.uk/preference/relay'
    },
    'idcta': {
        'urls': {
            'signin': 'https://ssl.bbc.co.uk/id/signin',
            'register': 'https://ssl.bbc.co.uk/id/register'
        }
    },
    'notificationsPollingInterval': 60000,
    'preferencesPollingInterval': 60000,
    'lockExpiry': 30000,
    'cacheTimeout': 600000,
    'visibleChunkAmount': 10,
    'maxNotificationAge': 5
};

module.exports = { env };



/** WEBPACK FOOTER **
 ** ./assets/js/config.js
 **/